import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import SidebarBoarding from "../../components/SidebarDashboard";
import CustomNavbar from "../../components/CustomNavbar";
import {
  getCourses,
  createCourse,
  editCourse,
  cancelCourse,
  getRegisteredEmployees,
} from "../../redux/capacitacionDesarrollo/Enrollment/actions";
import ReactExport from "react-export-excel";
import {
  Alert,
  Button,
  ButtonGroup,
  Card,
  Col,
  Form,
  Row,
  Spinner,
  Dropdown,
  Tooltip,
  OverlayTrigger,
  Badge,
  Modal,
  FormGroup,
  FormLabel,
  Tab,
  Nav,
} from "react-bootstrap";
import { BsPencilSquare, BsEye, BsPlus, BsXCircle } from "react-icons/bs";
import CustomTable from "../../components/CustomTable";
import CustomPagint from "../../components/CustomPagint";

// Filtros de búsqueda
const filters = [
  { id: "nombre", desc: "Nombre del curso" },
  { id: "fecha_inicio", desc: "Fecha de inicio" },
  { id: "estado_gestion", desc: "Estado" },
];

// Opciones de estado
const statusOptions = [
  { value: "programado", label: "Programado" },
  { value: "cancelado", label: "Cancelado" },
];

function CoursesManagement() {
  // Estados
  const dispatch = useDispatch();
  const [showSidebar, setShowSidebar] = useState(false);
  const onShowSidebar = () => setShowSidebar(!showSidebar);

  // Estado para paginación y filtros
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [filter, setFilter] = useState("");
  const [tipoBusqueda, setTipoBusqueda] = useState(filters[0]);

  // Estados para el modal
  const [showModal, setShowModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [currentCourse, setCurrentCourse] = useState(null);
  const [formData, setFormData] = useState({
    nombre: "",
    descripcion: "",
    objetivos: "",
    fecha_inicio_registro: "",
    fecha_fin_registro: "",
    fecha_inicio_curso: "",
    duracion_horas: "",
    instructor: "",
  });
  const [formErrors, setFormErrors] = useState({});
  const [editLoading, setEditLoading] = useState(false);

  const [showCancelModal, setShowCancelModal] = useState(false);
  const [courseToCancel, setCourseToCancel] = useState(null);

  const [showEmployeesModal, setShowEmployeesModal] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [currentCourseEmployees, setCurrentCourseEmployees] = useState(null);
  const [globalLoading, setGlobalLoading] = useState(false);

  // Exportar Excell
  const [exportData, setExportData] = useState([]);

  const ExcelFile = ReactExport.ExcelFile;
  const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
  const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

  //Store
  const { loaderCourses, courses, saveLoaderCourses } = useSelector(
    (store) => store.CoursesEnrollment
  );
  const { loaderRegisteredEmployees, registeredEmployees } = useSelector(
    (store) => store.CoursesEnrollment
  );
  const userId = useSelector((store) => store.auth.userId);

  // Obtener los datos de los cursos
  const data = Array.isArray(courses?.results) ? courses.results : [];
  const totalCount = courses?.count || 0;

  // Cantidad de páginas disponibles
  const pages = Math.ceil(totalCount / limit);

  const _getCourses = (
    offs = offset,
    lim = limit,
    tipo = tipoBusqueda.id,
    filt = filter
  ) => {
    dispatch(
      getCourses({
        offset: offs,
        size: lim,
        [tipo]: filt,
        page: Math.floor(offs / lim) + 1,
      })
    );
  };

  useEffect(() => {
    _getCourses();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, offset, limit]);

  const handlePagination = (newOffset) => {
    setOffset(newOffset);
    setCurrentPage(Math.ceil(newOffset / limit) + 1);
  };

  const onSearch = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    const searchValue = filter;
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getCourses(oOffset, limit, tipoBusqueda.id, searchValue);
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getCourses(oOffset, limit, tipoBusqueda.id, oSearch);
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case "programado":
        return "success";
      case "cancelado":
        return "danger";
      default:
        return "secondary";
    }
  };

  const handleCreate = () => {
    setModalTitle("Crear Nuevo Curso");
    setCurrentCourse(null);
    setFormData({
      nombre: "",
      descripcion: "",
      objetivos: "",
      fecha_inicio_registro: "",
      fecha_fin_registro: "",
      fecha_inicio_curso: "",
      duracion_horas: "",
      instructor: "",
    });
    setFormErrors({});
    setShowModal(true);
  };

  const handleEdit = (course) => {
    setModalTitle("Editar Curso");
    setCurrentCourse(course);
    setFormData({
      nombre: course.nombre,
      descripcion: course.descripcion,
      objetivos: course.objetivos || "",
      fecha_inicio_registro: course.fecha_inicio_registro,
      fecha_fin_registro: course.fecha_fin_registro,
      fecha_inicio_curso: course.fecha_inicio_curso,
      duracion_horas: course.duracion_horas,
      instructor: course.instructor,
    });
    setFormErrors({});
    setShowModal(true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (formErrors[name]) {
      setFormErrors((prev) => ({
        ...prev,
        [name]: null,
      }));
    }
  };

  const validateForm = () => {
    const errors = {};
    const requiredFields = [
      "nombre",
      "descripcion",
      "objetivos",
      "fecha_inicio_registro",
      "fecha_fin_registro",
      "fecha_inicio_curso",
      "duracion_horas",
      "instructor",
    ];

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        errors[field] = "Este campo es obligatorio";
      }
    });

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    try {
      if (currentCourse) {
        setEditLoading(true);

        const success = await dispatch(
          editCourse(currentCourse.id, {
            ...formData,
            actualizado_por: userId,
          })
        );
        setEditLoading(false);

        if (success) {
          setShowModal(false);
          _getCourses();
        }
      } else {
        const success = await dispatch(
          createCourse({
            ...formData,
            creado_por: userId,
          })
        );

        if (success) {
          setShowModal(false);
          _getCourses();
        }
      }
    } catch (error) {
      setEditLoading(false);
    }
  };

  const handleViewEmployees = async (courseId) => {
    try {
      setGlobalLoading(true);
      setCurrentCourseEmployees(courseId);
      const response = await dispatch(getRegisteredEmployees(courseId));

      const exportData =
        response?.matriculados?.map((matricula) => ({
          codigo: matricula.empleado?.codigo || "N/A",
          nombre: matricula.empleado?.nombre || "N/A",
          empresa: matricula.empleado?.empresa?.nombre || "N/A",
          estado: matricula.aprobado_por_jefatura ? "Aprobado" : "Pendiente",
        })) || [];

      setExportData(exportData);
      setShowEmployeesModal(true);
    } catch (error) {
      console.error("Error al obtener empleados:", error);
    } finally {
      setGlobalLoading(false);
    }
  };

  const handleCancelCourse = async () => {
    try {
      const success = await dispatch(
        cancelCourse(courseToCancel.id, {
          actualizado_por: userId,
        })
      );

      if (success) {
        setShowCancelModal(false);
        _getCourses();
      }
    } catch (error) {
      console.error("Error al cancelar el curso:", error);
    }
  };

  const columns = [
    {
      Header: "Nombre",
      accessor: "nombre",
      Filter: "",
    },
    {
      Header: "Descripción",
      accessor: "descripcion",
      Filter: "",
      Cell: ({ value }) => (
        <div className="text-truncate" style={{ maxWidth: "200px" }}>
          {value}
        </div>
      ),
    },
    {
      Header: "Fecha Inicio Curso",
      accessor: "fecha_inicio_curso",
      Filter: "",
    },
    {
      Header: "Duración (horas)",
      accessor: "duracion_horas",
      Filter: "",
    },
    {
      Header: "Instructor",
      accessor: "instructor",
      Filter: "",
    },
    {
      Header: "Estado",
      accessor: "estado_gestion",
      Filter: "",
      Cell: ({ value }) => (
        <Badge pill bg={getStatusBadge(value)}>
          {value}
        </Badge>
      ),
    },
    {
      Header: "Acciones",
      accessor: "acciones",
      Filter: "",
      Cell: ({ row }) => (
        <ButtonGroup>
          <Button
            variant="outline-primary"
            size="sm"
            onClick={() => handleEdit(row.original)}
            disabled={editLoading}
          >
            {editLoading && row.original.id === currentCourse?.id ? (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            ) : (
              <BsPencilSquare />
            )}
          </Button>

          <Button
            variant="outline-info"
            size="sm"
            onClick={() => handleViewEmployees(row.original.id)}
          >
            <BsEye />
          </Button>

          {row.original.estado_gestion === "programado" && (
            <Button
              variant="outline-danger"
              size="sm"
              onClick={() => {
                setCourseToCancel(row.original);
                setShowCancelModal(true);
              }}
            >
              <BsXCircle />
            </Button>
          )}
        </ButtonGroup>
      ),
    },
  ];

  return (
    <>
      <SidebarBoarding show={showSidebar} onShowSidebar={onShowSidebar} />
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      {globalLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.1)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
          className="d-flex justify-content-center align-items-center"
        >
          <Spinner
            animation="border"
            variant="primary"
            style={{ width: "3rem", height: "3rem" }}
          />
        </div>
      )}
      <div>
        <div className="my-1 d-flex flex-wrap justify-content-between align-items-center">
          <h5 className="ml-4">Administración de Cursos</h5>
          <Form onSubmit={onSearch}>
            <Row className="justify-content-end align-items-center flex-nowrap">
              <Col>
                <p>
                  <b>Búsqueda por: </b>
                  {tipoBusqueda.desc}
                </p>
              </Col>
              <Col xs="auto">
                {tipoBusqueda.id === "estado_gestion" ? (
                  <Dropdown>
                    <Dropdown.Toggle variant="light" className="rounded-pill">
                      {filter || "Seleccionar estado"}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {statusOptions.map((status) => (
                        <Dropdown.Item
                          key={status.value}
                          onClick={() => {
                            setFilter(status.value);
                            const oOffset = 0;
                            setOffset(oOffset);
                            setCurrentPage(1);
                            _getCourses(
                              oOffset,
                              limit,
                              tipoBusqueda.id,
                              status.value
                            );
                          }}
                        >
                          {status.label}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                ) : (
                  <Form.Control
                    name="filter"
                    id="filter"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                    type={
                      tipoBusqueda.id === "fecha_inicio" ? "date" : "search"
                    }
                    value={filter}
                    onChange={(e) => {
                      setFilter(e.target.value);
                      if (tipoBusqueda.id === "fecha_inicio") {
                        const oOffset = 0;
                        setOffset(oOffset);
                        setCurrentPage(1);
                        _getCourses(
                          oOffset,
                          limit,
                          tipoBusqueda.id,
                          e.target.value
                        );
                      }
                    }}
                    onKeyPress={(e) => {
                      if (
                        e.key === "Enter" &&
                        tipoBusqueda.id !== "fecha_inicio"
                      ) {
                        onSearch(e);
                      }
                    }}
                  />
                )}
              </Col>
              <Col xs="auto">
                <ButtonGroup>
                  <Button
                    onClick={() => seeAll()}
                    variant="light"
                    size="sm"
                    className="rounded-circle"
                  >
                    <i className="material-icons">list</i>
                  </Button>
                  <ButtonGroup>
                    <OverlayTrigger
                      placement="auto"
                      overlay={<Tooltip>Seleccionar Filtrado</Tooltip>}
                    >
                      <Dropdown className="ml-3 mr-3">
                        <Dropdown.Toggle
                          variant="light"
                          className="btn-sm font rounded-pill"
                        >
                          <i className="material-icons">filter_list</i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {filters.map((item) => (
                            <Dropdown.Item
                              onClick={() => {
                                setTipoBusqueda(item);
                                setFilter("");
                              }}
                              key={item.id}
                            >
                              {item.desc}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </OverlayTrigger>
                  </ButtonGroup>
                  <Button
                    variant="light"
                    size="sm"
                    className="rounded-pill"
                    onClick={handleCreate}
                  >
                    <BsPlus size={20} />
                  </Button>
                </ButtonGroup>
              </Col>
            </Row>
          </Form>
        </div>

        {loaderCourses ? (
          <div className="d-flex justify-content-center mt-4">
            <Spinner animation="border" role="status" />
          </div>
        ) : data && data.length > 0 ? (
          <>
            <Card className="border-0">
              <Card.Body className="px-1 px-sm-2">
                <CustomTable columns={columns} data={data} />
              </Card.Body>
            </Card>
            <CustomPagint
              limit={limit}
              setLimit={setLimit}
              offset={offset}
              setOffset={handlePagination}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              dataLenght={totalCount}
              pages={pages}
              pagFunc={() => {}}
            />
          </>
        ) : (
          <Alert variant="info" className="my-4">
            No se encontraron cursos.
          </Alert>
        )}

        {/* Modal para crear/editar cursos */}
        <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>{modalTitle}</Modal.Title>
          </Modal.Header>
          <Form onSubmit={handleSubmit}>
            <Modal.Body>
              {Object.keys(formErrors).length > 0 && (
                <Alert variant="danger" className="mb-3">
                  Por favor complete todos los campos obligatorios.
                </Alert>
              )}

              <Tab.Container defaultActiveKey="general">
                <Nav variant="tabs" className="mb-3">
                  <Nav.Item>
                    <Nav.Link eventKey="general">General</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="details">Detalles del Curso</Nav.Link>
                  </Nav.Item>
                </Nav>
                <Tab.Content>
                  <Tab.Pane eventKey="general">
                    <Row className="mb-1">
                      <Col md={12}>
                        <FormGroup className="mb-1">
                          <FormLabel>Nombre del curso</FormLabel>
                          <Form.Control
                            type="text"
                            name="nombre"
                            value={formData.nombre}
                            onChange={handleChange}
                            isInvalid={!!formErrors.nombre}
                          />
                          <Form.Control.Feedback type="invalid">
                            {formErrors.nombre}
                          </Form.Control.Feedback>
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row className="mb-1">
                      <Col>
                        <FormGroup className="mb-1">
                          <FormLabel>Descripción</FormLabel>
                          <Form.Control
                            as="textarea"
                            name="descripcion"
                            value={formData.descripcion}
                            onChange={handleChange}
                            isInvalid={!!formErrors.descripcion}
                            style={{ height: "50px" }}
                          />
                          <Form.Control.Feedback type="invalid">
                            {formErrors.descripcion}
                          </Form.Control.Feedback>
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row className="mb-1">
                      <Col>
                        <FormGroup className="mb-1">
                          <FormLabel>Objetivos</FormLabel>
                          <Form.Control
                            as="textarea"
                            name="objetivos"
                            value={formData.objetivos}
                            onChange={handleChange}
                            isInvalid={!!formErrors.objetivos}
                            style={{ height: "50px" }}
                          />
                          <Form.Control.Feedback type="invalid">
                            {formErrors.objetivos}
                          </Form.Control.Feedback>
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row className="mb-1">
                      <Col md={6}>
                        <FormGroup className="mb-1">
                          <FormLabel>Fecha inicio registro</FormLabel>
                          <Form.Control
                            type="date"
                            name="fecha_inicio_registro"
                            value={formData.fecha_inicio_registro}
                            onChange={handleChange}
                            isInvalid={!!formErrors.fecha_inicio_registro}
                          />
                          <Form.Control.Feedback type="invalid">
                            {formErrors.fecha_inicio_registro}
                          </Form.Control.Feedback>
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup className="mb-1">
                          <FormLabel>Fecha fin registro</FormLabel>
                          <Form.Control
                            type="date"
                            name="fecha_fin_registro"
                            value={formData.fecha_fin_registro}
                            onChange={handleChange}
                            isInvalid={!!formErrors.fecha_fin_registro}
                          />
                          <Form.Control.Feedback type="invalid">
                            {formErrors.fecha_fin_registro}
                          </Form.Control.Feedback>
                        </FormGroup>
                      </Col>
                    </Row>
                  </Tab.Pane>

                  <Tab.Pane eventKey="details">
                    <Row className="mb-1">
                      <Col md={12}>
                        <FormGroup className="mb-1">
                          <FormLabel>Instructor</FormLabel>
                          <Form.Control
                            type="text"
                            name="instructor"
                            value={formData.instructor}
                            onChange={handleChange}
                            isInvalid={!!formErrors.instructor}
                          />
                          <Form.Control.Feedback type="invalid">
                            {formErrors.instructor}
                          </Form.Control.Feedback>
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row className="mb-1">
                      <Col md={6}>
                        <FormGroup className="mb-1">
                          <FormLabel>Fecha inicio curso</FormLabel>
                          <Form.Control
                            type="date"
                            name="fecha_inicio_curso"
                            value={formData.fecha_inicio_curso}
                            onChange={handleChange}
                            isInvalid={!!formErrors.fecha_inicio_curso}
                          />
                          <Form.Control.Feedback type="invalid">
                            {formErrors.fecha_inicio_curso}
                          </Form.Control.Feedback>
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup className="mb-1">
                          <FormLabel>Duración (horas)</FormLabel>
                          <Form.Control
                            type="number"
                            name="duracion_horas"
                            value={formData.duracion_horas}
                            onChange={handleChange}
                            isInvalid={!!formErrors.duracion_horas}
                            min="1"
                          />
                          <Form.Control.Feedback type="invalid">
                            {formErrors.duracion_horas}
                          </Form.Control.Feedback>
                        </FormGroup>
                      </Col>
                    </Row>
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </Modal.Body>

            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowModal(false)}>
                Cancelar
              </Button>
              <Button
                variant="primary"
                type="submit"
                disabled={saveLoaderCourses || editLoading}
              >
                {saveLoaderCourses || editLoading ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                    <span className="ms-2">Guardando...</span>
                  </>
                ) : currentCourse ? (
                  "Guardar Cambios"
                ) : (
                  "Crear Curso"
                )}
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      </div>
      <Modal
        show={showCancelModal}
        onHide={() => setShowCancelModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirmar Cancelación</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          ¿Estás seguro que deseas cancelar el curso "{courseToCancel?.nombre}"?
          <br />
          Esta acción no se puede deshacer.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowCancelModal(false)}>
            Cancelar
          </Button>
          <Button variant="danger" onClick={handleCancelCourse}>
            Confirmar Cancelación
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showEmployeesModal}
        onHide={() => setShowEmployeesModal(false)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Empleados Registrados -{" "}
            {registeredEmployees?.curso_nombre || "Curso"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-3">
            <strong>Total registrados:</strong>{" "}
            {registeredEmployees?.total_matriculados || 0}
          </p>

          {loaderRegisteredEmployees ? (
            <div className="d-flex justify-content-center">
              <Spinner animation="border" />
            </div>
          ) : (
            <div style={{ maxHeight: "400px", overflowY: "auto" }}>
              <table className="table table-striped table-hover">
                <thead>
                  <tr>
                    <th>Fecha Matrícula</th>
                    <th>Nombre Empleado</th>
                    <th>Código</th>
                    <th>Empresa</th>
                    <th>Aprobado por Jefatura</th>
                  </tr>
                </thead>
                <tbody>
                  {registeredEmployees?.matriculados?.length > 0 ? (
                    registeredEmployees.matriculados.map((matricula) => (
                      <tr key={matricula.matricula_id}>
                        <td>
                          {new Date(
                            matricula.fecha_matricula
                          ).toLocaleDateString()}
                        </td>
                        <td>{matricula.empleado?.nombre || "N/A"}</td>
                        <td>{matricula.empleado?.codigo || "N/A"}</td>
                        <td>
                          {matricula.empleado?.empresa?.nombre || "N/A"}
                          {matricula.empleado?.empresa?.codigo &&
                            ` (${matricula.empleado.empresa.codigo})`}
                        </td>
                        <td>
                          <Badge
                            pill
                            bg={
                              matricula.aprobado_por_jefatura
                                ? "success"
                                : "warning"
                            }
                          >
                            {matricula.aprobado_por_jefatura
                              ? "Aprobado"
                              : "Pendiente"}
                          </Badge>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center">
                        No hay empleados registrados en este curso
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <ExcelFile
            element={
              <Button variant="success" className="me-2">
                Exportar a Excel
              </Button>
            }
            filename={`Empleados_${
              registeredEmployees?.curso_nombre || "Curso"
            }`}
          >
            <ExcelSheet data={exportData} name="Empleados Registrados">
              <ExcelColumn label="Código" value="codigo" />
              <ExcelColumn label="Nombre" value="nombre" />
              <ExcelColumn label="Empresa" value="empresa" />
              <ExcelColumn label="Aprobado por Jefatura" value="estado" />
            </ExcelSheet>
          </ExcelFile>

          <Button
            variant="secondary"
            onClick={() => setShowEmployeesModal(false)}
          >
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default CoursesManagement;
